export const isEmpty = (value: any) => value == null
